import { render } from "./ElFooter.vue?vue&type=template&id=279bb34d&lang=html"
import script from "./ElFooter.vue?vue&type=script&lang=js"
export * from "./ElFooter.vue?vue&type=script&lang=js"

import "./ElFooter.vue?vue&type=style&index=0&id=279bb34d&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__